/*
 *  Author: DL
 *  Date: 2020-12-05 19:34:44
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-18 13:53:44
 *  LastEditors: DL
 *  Description: 输入框
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React, { forwardRef } from 'react';
import styles from './index.less';

export default forwardRef(function(props, ref) {
    return (
        <div className={styles.wrapper}>
            <span className={styles.prefix}>{props.text}</span>
            <input className={styles.input} ref={ref} {...props} />
        </div>
    );
});
